export const VTMN_PROGRESSBAR_VARIANT = {
  CIRCULAR: 'circular',
  LINEAR: 'linear',
};

export const VTMN_PROGRESSBAR_SIZE = {
  MEDIUM: 'medium',
  SMALL: 'small',
  LARGE: 'large',
};
